<app-base-edit-form-modal
  [fields]="fields"
  [id]="id()"
  [parentId]="userId()"
  [baseService]="userPrinterService"
  (saved)="saved()"
>
</app-base-edit-form-modal>
